import { HttpErrorResponse } from '@angular/common/http';
import { ErrorReason } from '@mynexus/mynexus-ui-lib';

const referralAssignErrorMatcher = 'cannot be assigned because it was already assigned to clinician';


export const isDuplicatedAssignReferralError = (error: HttpErrorResponse): boolean => {
  const reasonId = error.error?.reasonId;
  const message = error.error?.errorData?.message;
  if (reasonId && message) {
    return reasonId === ErrorReason.InvalidContent && message.includes(referralAssignErrorMatcher);
  }
  return false;
};
